import * as THREE from "three";
import { MathUtils, Vector2, Vector3 } from "three";
import { panelColor, panelMetal, panelNormal, panelRoughness } from "../../assets/materials";
import { ModelSkeleton } from "./ModelSkeleton";
export class BioclimaticModelSkeleton extends ModelSkeleton {
    createModule(pos, modulePlaceZ, modulePlaceX) {
        const modulesZ = this.data.measuredModel.modulesZ;
        const modulesX = this.data.measuredModel.modulesX;
        const opened = this.data.measuredModel.model.id == 2;
        const moduleWidth = this.data.measuredModel.width;
        const moduleProjection = this.data.measuredModel.projection;
        const edgeWidth = this.data.measuredModel.model.edgeWidth;
        const edgeHeight = this.data.measuredModel.model.edgeHeight;
        const panelStep = this.data.measuredModel.model.step;
        const panels = Math.ceil((moduleProjection) / panelStep);
        const beamSizeProjection = new Vector3(moduleProjection, edgeHeight, edgeWidth);
        const beamSizeWidth = new Vector3(moduleWidth, edgeHeight, edgeWidth);
        const pillarSize = new Vector3(edgeWidth, 260, edgeWidth);
        // Edges
        this.createEdge(new Vector3(pos.x, pos.y, pos.z - moduleWidth / 2 + edgeWidth / 2), beamSizeProjection, 0);
        this.createEdge(new Vector3(pos.x, pos.y, pos.z + moduleWidth / 2 - edgeWidth / 2), beamSizeProjection, 0);
        this.createEdge(new Vector3(pos.x - moduleProjection / 2, pos.y, pos.z), beamSizeWidth, 90);
        this.createEdge(new Vector3(pos.x + moduleProjection / 2, pos.y, pos.z), beamSizeWidth, 90);
        // Roof
        // Panels (skip 1st because it spawns into edge)
        this.createPanels(new Vector3(pos.x, pos.y + edgeWidth / 2, pos.z), new Vector3(moduleWidth - edgeWidth * 2, panelStep, 1), 90, panels, opened);
        //Corner Pillars
        const top = pos.x - moduleProjection / 2;
        const bottom = pos.x + moduleProjection / 2;
        const middle = pos.x;
        const left = pos.z + moduleWidth / 2 - pillarSize.z / 2;
        const right = pos.z - moduleWidth / 2 + pillarSize.z / 2;
        const y = pos.y - pillarSize.y / 2;
        const leftSide = this.data.left.wall;
        const rightSide = this.data.right.wall;
        const closeSide = this.data.close.wall;
        const farSide = this.data.far.wall;
        if (this.data.freestanding) {
            this.createPillar(new Vector3(top, y, left), pillarSize, edgeHeight);
            this.createPillar(new Vector3(top, y, right), pillarSize, edgeHeight);
            this.createPillar(new Vector3(bottom, y, left), pillarSize, edgeHeight);
            this.createPillar(new Vector3(bottom, y, right), pillarSize, edgeHeight);
        }
        else {
            // Calculates which side pillars to hide.
            if (this.data.measuredModel.rotated) {
                if (leftSide === true && modulePlaceX === 0 || closeSide === true && modulePlaceZ === modulesZ) { }
                else {
                    this.createPillar(new Vector3(top, y, left), pillarSize, edgeHeight);
                }
                if (closeSide === true && modulePlaceZ === modulesZ || rightSide === true && modulePlaceX === modulesX - 1) { }
                else {
                    this.createPillar(new Vector3(bottom, y, left), pillarSize, edgeHeight);
                }
                if (rightSide === true && modulePlaceX === modulesX - 1 || farSide === true && modulePlaceZ === 1) { }
                else {
                    this.createPillar(new Vector3(bottom, y, right), pillarSize, edgeHeight);
                }
                if (farSide === true && modulePlaceZ === 1 || leftSide === true && modulePlaceX === 0) { }
                else {
                    this.createPillar(new Vector3(top, y, right), pillarSize, edgeHeight);
                }
            }
            else {
                if (leftSide === true && modulePlaceZ === modulesZ || closeSide === true && modulePlaceX === modulesX - 1) { }
                else {
                    this.createPillar(new Vector3(bottom, y, left), pillarSize, edgeHeight);
                }
                if (closeSide === true && modulePlaceX === modulesX - 1 || rightSide === true && modulePlaceZ === 1) { }
                else {
                    this.createPillar(new Vector3(bottom, y, right), pillarSize, edgeHeight);
                }
                if (rightSide === true && modulePlaceZ === 1 || farSide === true && modulePlaceX === 0) { }
                else {
                    this.createPillar(new Vector3(top, y, right), pillarSize, edgeHeight);
                }
                if (farSide === true && modulePlaceX === 0 || leftSide === true && modulePlaceZ === modulesZ) { }
                else {
                    this.createPillar(new Vector3(top, y, left), pillarSize, edgeHeight);
                }
            }
        }
        //Middle pillars over 600cm
        if (moduleProjection > 600) {
            if (this.data.measuredModel.rotated) {
                if (this.data.freestanding) {
                    this.createPillar(new Vector3(middle, y, right), pillarSize, edgeHeight);
                    this.createPillar(new Vector3(middle, y, left), pillarSize, edgeHeight);
                }
                else {
                    if (farSide === true && modulePlaceZ === 1) { }
                    else {
                        this.createPillar(new Vector3(middle, y, right), pillarSize, edgeHeight);
                    }
                    if (closeSide === false)
                        this.createPillar(new Vector3(middle, y, left), pillarSize, edgeHeight);
                }
            }
            else {
                if (this.data.freestanding) {
                    this.createPillar(new Vector3(middle, y, left), pillarSize, edgeHeight);
                    this.createPillar(new Vector3(middle, y, right), pillarSize, edgeHeight);
                }
                else {
                    if (rightSide === true && modulePlaceZ === 1) { }
                    else {
                        this.createPillar(new Vector3(middle, y, right), pillarSize, edgeHeight);
                    }
                    if (leftSide === false)
                        this.createPillar(new Vector3(middle, y, left), pillarSize, edgeHeight);
                }
            }
        }
    }
    createPanelLights(pos, size, rotation, panels, opened) {
        const mat = new THREE.MeshBasicMaterial({ color: 0xF9F8D3 });
        const geom = new THREE.BoxGeometry(6, 1, 25);
        const mesh = new THREE.InstancedMesh(geom, mat, panels + 1);
        for (let i = 2; i < panels; i += 5) {
            let xStep;
            if (opened) {
                xStep = 7;
            }
            else {
                xStep = this.data.measuredModel.projection / panels;
            }
            const x = pos.x - this.data.measuredModel.projection / 2 + (i * xStep);
            const finalPos = new THREE.Vector3(x, pos.y - 0.5, pos.z);
            const lightCount = this.data.measuredModel.width >= 300 ? 3 : 2;
            for (let x = 0; x < lightCount; x++) {
                if (lightCount === 3) {
                    finalPos.z = pos.z - this.data.measuredModel.width / 4 + this.data.measuredModel.width / 4 * x;
                    mesh.setMatrixAt(i + x, new THREE.Matrix4().compose(finalPos, new THREE.Quaternion(), new THREE.Vector3(1, 1, 1)));
                }
                else {
                    if (x === 0) {
                        finalPos.z = pos.z - this.data.measuredModel.width / 4;
                    }
                    else {
                        finalPos.z = pos.z + this.data.measuredModel.width / 4;
                    }
                    mesh.setMatrixAt(i + x, new THREE.Matrix4().compose(finalPos, new THREE.Quaternion(), new THREE.Vector3(1, 1, 1)));
                }
            }
        }
        this.scene.threeScene.add(mesh);
    }
    createPanels(pos, size, rotation, panels, opened) {
        let mat;
        let panelRot;
        /** Extra perimeter light added here **/
        if (this.scene.formData.extras.panelLed === false) {
            panelRot = 30;
            mat = this.scene.materialPicker.getMaterial(undefined, undefined, false);
        }
        else {
            mat = this.scene.materialPicker.getMaterial(undefined, undefined, false, 0.2);
            mat.map = panelColor;
            mat.metalnessMap = panelMetal;
            mat.roughnessMap = panelRoughness;
            /*			let normalMap = new THREE.Texture()
                        this.scene.assignTexture(normalMap, panelNormal);
                        normalMap.repeat = new Vector2(size.x / 1024 * 24, 50)*/
            mat.normalMap = panelNormal;
            panelRot = 90;
            this.createPanelLights(pos, size, rotation, panels, opened);
        }
        const geom = new THREE.BoxGeometry(size.x, size.y, size.z).rotateX(MathUtils.degToRad(panelRot)).rotateY(MathUtils.degToRad(rotation));
        const mesh = new THREE.InstancedMesh(geom, mat, panels);
        for (let i = 1; i < panels; i++) {
            let xStep;
            if (opened) {
                xStep = 7;
            }
            else {
                xStep = this.data.measuredModel.projection / panels;
            }
            const x = pos.x - this.data.measuredModel.projection / 2 + i * xStep;
            //const x = this.scene.dimensions.far.position.x + i * xStep
            const finalPos = new THREE.Vector3(x, pos.y, pos.z);
            mesh.setMatrixAt(i, new THREE.Matrix4().compose(finalPos, new THREE.Quaternion(), new THREE.Vector3(1, 1, 1)));
        }
        mesh.castShadow = true;
        this.scene.threeScene.add(mesh);
    }
    createPillar(pos, size, beamSize) {
        const pillarTextureRepeat = new Vector2(size.x / 1024 * 24, size.y / 1024 * 24);
        const cubeGeometry = new THREE.BoxGeometry(size.x, size.y - 0.3, size.z);
        const edgeMat = this.scene.materialPicker.getMaterial(pillarTextureRepeat);
        const cubeMesh = new THREE.Mesh(cubeGeometry, edgeMat);
        cubeMesh.castShadow = true;
        cubeMesh.position.set(pos.x, pos.y + beamSize / 2, pos.z);
        this.scene.threeScene.add(cubeMesh);
    }
}
